import React from 'react';
import CloseBtn from '../../../../../../../myaccount/src/stories/components/RefundRaiseRequest/assets/cancel.png';
import * as S from './FileUploaded.styles';

const FileUploaded = ({title, fileSize, closeIcon, onClose}) => {
  return (
    <S.Container>
      {closeIcon && (
        <S.CloseIcon onClick={onClose}>
          <img src={CloseBtn} />
        </S.CloseIcon>
      )}
      {title && <p>{title}</p>}
      {fileSize && <p>{fileSize}</p>}
    </S.Container>
  );
};

export default FileUploaded;
